
import { Navigate } from 'react-router';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { hasPermission } from '../permissions/permissions';

export default function PermissionGuard({ permission, children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (permission && !hasPermission(user, permission)) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6">Acces refuse</Typography>
        <Typography color="text.secondary">Ton role ne permet pas d'acceder a cette vue.</Typography>
      </Box>
    );
  }

  return children;
}
